<template>
  <el-submenu 
    v-if="menu.list && menu.list.length >= 1"
    :index="menu.url+''"
    >
    <template slot="title">
      <!-- <icon-svg :name="menu.icon || ''" class="site-sidebar__menu-icon"></icon-svg> -->
      <span>{{ menu.name }}</span>
    </template>
    <sub-menu
      v-for="item in menu.list" 
      :key="item.menuId"
      :menu="item"
      :dynamicMenuRoutes="dynamicMenuRoutes">
    </sub-menu>
  </el-submenu>
  <el-menu-item v-else :index="menu.url+''" @click="gotoRouteHandle(menu)">
    <i :class="menu.icon || ''" class="site-sidebar__menu-icon" style="color: #bdcbd9;margin-right: 8px;"></i>
    <span>{{ menu.name }}</span>
  </el-menu-item>
</template>

<script>
  import SubMenu from './main-sidebar-sub-menu'
  export default {
    name: 'sub-menu',
    props: {
      menu: {
        type: Object,
        required: true
      },
      dynamicMenuRoutes: {
        type: Array,
        required: true
      }
    },
    components: {
      SubMenu
    },
    computed: {
      // sidebarLayoutSkin: {
      //   get () { return this.$store.state.common.sidebarLayoutSkin }
      // }
    },
    methods: {
      // 通过menuId与动态(菜单)路由进行匹配跳转至指定路由
      gotoRouteHandle (menu) {
        this.$router.push(menu.url);
      }
    }
  }
</script>
